module.exports = __webpack_public_path__ + "0ea04502930623aa3de110aac9f9e4fd.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Semibold/OpenSans-Semibold.eot?v=1.1.0
// module id = 992
// module chunks = 0